import { render, staticRenderFns } from "./CodeInput.vue?vue&type=template&id=4894f40f&scoped=true&"
import script from "./CodeInput.vue?vue&type=script&lang=js&"
export * from "./CodeInput.vue?vue&type=script&lang=js&"
import style0 from "./CodeInput.vue?vue&type=style&index=0&id=4894f40f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894f40f",
  null
  
)

export default component.exports